export const ProfileComponent = {
    template: `
        <oo-content>
            <oo-content-header class="hide-sm">
                My Account
            </oo-content-header>
            <oo-content-body>
                <oo-tabs oo-theme="light">
                    <oo-tab title="My Profile">
                        <basic-info-authenticated
                            first-name="$ctrl.data.basicInfo.firstName"
                            last-name="$ctrl.data.basicInfo.lastName"
                            email="$ctrl.data.basicInfo.email"
                            phone-number="$ctrl.data.basicInfo.phoneNumber"
                        ></basic-info-authenticated>
                        <password></password>
                        <addresses></addresses>
                        <credit-cards></credit-cards>
                    </oo-tab>
                </oo-tabs>
            </oo-content-body>
        </oo-content>`,
    controller: class ProfileComponent {
        constructor(accountService, $state) {
            'ngInject';
            this.accountService = accountService;
            this.$state = $state;
            this.data = accountService.data;
        }
        $onInit() {
            this.accountService.getBasicInfo()
                .then(
                    null,
                    () => { this.$state.go('order'); }
                );
        }
    }
};
